<!------------------------------

      Page Actions

------------------------------->


@if (!isInIntegratedContext && !isInModalContext) {
  <ng-container *sbPageAction>
    @if (!preselectType && permissionService.hasPermissions([permissionService.Permission.cull_create, permissionService.Permission.cull_time_create, permissionService.Permission.cull_player_create, permissionService.Permission.cull_geo_create])) {
      <button
        sb-button-primary
        type="button"
        color="green"
        icon="plus"
        sbTooltip="{{ 'lang.devices.createCull' | translate }}" container="body"
        [iconButton]="true"
        [sbRouterLink]="util.RoutingID.filterCreate"
        [queryParams]="{returnTo: util.getPageLink()}">
      </button>
    }
    <button
      type="button"
      sb-button-primary
      icon="refresh"
      [iconButton]="true"
      [color]="'blue'"
      (click)="requestDebounced()"
      [disabled]="loading()"
      [loading]="loading()"
      sbTooltip="{{ 'lang.globals.refresh' | translate }}" container="body"
      placement="top">
    </button>
    <button
      *ngPermissions="permissionService.Permission.cull_category_list"
      type="button"
      sb-button-primary
      icon="refresh"
      sbTooltip="{{ 'lang.globals.cullCategories' | translate }}" container="body"
      [iconButton]="true"
      [color]="'blue'"
      icon="category"
      [disabled]="loading()"
      [sbRouterLink]="util.RoutingID.cullCategories">
    </button>
  </ng-container>
}

<!------------------------------

    Table Wrapper

------------------------------->

@let ordering = orderOption();
<sb-table-wrapper-new
  headline="{{'lang.headlines.culls' | translate}}"
  [itemName]="'culls'" [itemsData]="elements"
  [loading]="loading()"
  [isInIntegratedContext]="isInIntegratedContext"
  [isInModalContext]="isInModalContext"
  (paginationChange)="requestDebounced($event)"
>

  <!------------------------------

      Filter

------------------------------->

  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      #FilterPanelRef
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
      filterID="search"
    >

      <sb-filter-section
        [initiallyExpanded]="true"
        title="{{'lang.globals.showHiddenHeadline' |translate}}" icon="eye"
        classes="tw-flex tw-flex-col tw-gap-2">
        <sb-filter-toggle filterID="hidden" [label]="'lang.globals.showHidden' | translate"></sb-filter-toggle>
      </sb-filter-section>
      <sb-filter-section
        title="{{'lang.globals.type' |translate}}" icon="selection"
        classes="tw-flex tw-flex-col tw-gap-2">
        <sb-filter-list-select filterID="cullType" [isSingleSelect]="true" [items]="cullTypes"></sb-filter-list-select>
      </sb-filter-section>
      <sb-filter-section
        title="{{'lang.globals.filterAttributes' |translate}}" icon="wrench"
        classes="tw-flex tw-flex-col tw-gap-2">
        <sb-filter-threeway-toggle filterID="isLocked" [default]="null"
                                   [label]="'lang.globals.locked' | translate"></sb-filter-threeway-toggle>
        <sb-filter-threeway-toggle filterID="hasCategory" [default]="null"
                                   [label]="'lang.globals.cullCategory' | translate"></sb-filter-threeway-toggle>
        <sb-filter-threeway-toggle filterID="isInUse" [default]="null"
                                   [label]="'lang.globals.inUse' | translate"></sb-filter-threeway-toggle>
        <sb-filter-threeway-toggle filterID="isCurrentlyInUse" [default]="null"
                                   [label]="'lang.globals.currentlyInUse' | translate"></sb-filter-threeway-toggle>
      </sb-filter-section>
      <sb-filter-section *ngPermissions="permissionService.Permission.company_list" title="{{'lang.globals.companies' | translate}}"
                         icon="company">
        <sb-filter-dto-list-select filterID="companies" [isSingleSelect]="true" [endpoint]="api.shared_Company_retrieveAll.bind(api)">
        </sb-filter-dto-list-select>
      </sb-filter-section>
      <sb-filter-section *ngPermissions="permissionService.Permission.cull_category_list"
                         title="{{'lang.globals.cullCategories' | translate}}" icon="category">
        <sb-filter-dto-list-select filterID="categories" [isSingleSelect]="true" [endpoint]="api.ca_md_CullCategory_retrieveAll.bind(api)">
        </sb-filter-dto-list-select>
      </sb-filter-section>


      <ng-template #orderSection>
        <sb-filter-section
          [alwaysExpanded]="true" [hideValueIndicatorIfDefaultSelected]="true" [showTag]="false"
          title="{{'lang.globals.order' | translate}}" icon="sort">
          <sb-filter-order
            [allOrderOptions]="allOrderOptions|omit: 'direction'"
            [selectedOrderOption]="orderOption()"
          >
          </sb-filter-order>
        </sb-filter-section>
      </ng-template>
    </sb-filter-panel>
  </div>

  <!------------------------------

      Table Header

------------------------------->
  <ng-template #thead>
    <tr>
      <th>{{ 'lang.globals.type' | translate }}</th>
      <th class="table--sortable" (click)="setToOrderAndRefresh(cs_Cull_retrieveAll_order.NAME)"
          [ngClass]="{'table--sorted': ordering?.value===cs_Cull_retrieveAll_order.NAME}">
        {{ 'lang.globals.title' | translate }}
        @if (ordering.value === cs_Cull_retrieveAll_order.NAME) {
          @if (ordering.direction === 'desc') {
            <sb-icon icon="sortDownFilled" class="icon-in-btn"></sb-icon>
          } @else {
            <sb-icon icon="sortUpFilled" class="icon-in-btn"></sb-icon>
          }
        } @else {
          <sb-icon
            icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
        }
      </th>
      <th>{{ 'lang.deviceFilterList.scope' | translate }}</th>
      <th class="table--sortable" (click)="setToOrderAndRefresh(cs_Cull_retrieveAll_order.CURRENT_USAGE_COUNT)"
          [ngClass]="{'table--sorted': ordering?.value===cs_Cull_retrieveAll_order.CURRENT_USAGE_COUNT}">
        {{ 'lang.deviceFilterList.currentUsageCount' | translate }}
        @if (ordering.value === cs_Cull_retrieveAll_order.CURRENT_USAGE_COUNT) {
          @if (ordering.direction === 'desc') {
            <sb-icon icon="sortDownFilled" class="icon-in-btn"></sb-icon>
          } @else {
            <sb-icon icon="sortUpFilled" class="icon-in-btn"></sb-icon>
          }
        } @else {
          <sb-icon
            icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
        }
      </th>
      <th class="table--sortable" (click)="setToOrderAndRefresh(cs_Cull_retrieveAll_order.USAGE_COUNT)"
          [ngClass]="{'table--sorted': ordering?.value===cs_Cull_retrieveAll_order.USAGE_COUNT}">
        {{ 'lang.deviceFilterList.usageCount' | translate }}
        @if (ordering.value === cs_Cull_retrieveAll_order.USAGE_COUNT) {
          @if (ordering.direction === 'desc') {
            <sb-icon icon="sortDownFilled" class="icon-in-btn"></sb-icon>
          } @else {
            <sb-icon icon="sortUpFilled" class="icon-in-btn"></sb-icon>
          }
        } @else {
          <sb-icon
            icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
        }
      </th>
      <th>{{ 'lang.globals.cullCategory' | translate }}</th>
      <th>{{ 'lang.globals.lockedBy' | translate }}</th>
      <th class="table--sortable" (click)="setToOrderAndRefresh(cs_Cull_retrieveAll_order.MODIFIED_AT)"
          [ngClass]="{'table--sorted': ordering?.value===cs_Cull_retrieveAll_order.MODIFIED_AT}">
        {{ 'lang.globals.modifiedAt' | translate }}
        @if (ordering.value === cs_Cull_retrieveAll_order.MODIFIED_AT) {
          @if (ordering.direction === 'desc') {
            <sb-icon icon="sortDownFilled" class="icon-in-btn"></sb-icon>
          } @else {
            <sb-icon icon="sortUpFilled" class="icon-in-btn"></sb-icon>
          }
        } @else {
          <sb-icon
            icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
        }
      </th>
      <th class="table--sortable" (click)="setToOrderAndRefresh(cs_Cull_retrieveAll_order.CREATED_AT)"
          [ngClass]="{'table--sorted': ordering?.value===cs_Cull_retrieveAll_order.CREATED_AT}">
        {{ 'lang.globals.createdAt' | translate }}
        @if (ordering.value === cs_Cull_retrieveAll_order.CREATED_AT) {
          @if (ordering.direction === 'desc') {
            <sb-icon icon="sortDownFilled" class="icon-in-btn"></sb-icon>
          } @else {
            <sb-icon icon="sortUpFilled" class="icon-in-btn"></sb-icon>
          }
        } @else {
          <sb-icon
            icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
        }
      </th>
      <th class="sticky-col last-col">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>

  <!------------------------------

    Table Body

------------------------------->
  <ng-template #tbody let-filter>
    <tr>
      <td>
        @switch (filter.type) {
          @case ('TimeCull') {
            <sb-icon icon="calendar"></sb-icon>
          }
          @case ('ClientCull') {
            <sb-icon icon="company"></sb-icon>
          }
          @case ('GeoCull') {
            <sb-icon icon="locationStreet"></sb-icon>
          }
          @case ('PlayerCull') {
            <sb-icon icon="playerOnline"></sb-icon>
          }
          @case ('ContentCull') {
            <sb-icon icon="screenPlay"></sb-icon>
          }
        }
      </td>
      <td>
        <sb-comp-name-wrapper>
          <sb-comp-link
            [condition]="!preselectType && !isInModalContext && permissionService.hasPermission(permissionService.Permission.cull_show)"
            [link]="util.RoutingID.filterDetails"
            [pathParams]="[{id: 'filterID', value: filter?.id}]"
            [title]="filter?.name | truncate: 45" firstLine>
          </sb-comp-link>
          <sb-tags
            *ngPermissions="[permissionService.Permission.tag_list]"
            [dtoId]="filter.id"
            [dtoType]="tagService.TaggableDTO.Cull" [editable]="!isInModalContext || !isInIntegratedContext"
            [tags]="filter.tags" secondLine>
          </sb-tags>
        </sb-comp-name-wrapper>

      </td>
      <td>
        {{ filter?.company?.name ?? filter?.global ? 'global' : 'client' }}
      </td>
      <td>
        {{ filter?.currentUsageCount }}
      </td>
      <td>
        {{ filter?.usageCount }}
      </td>
      <td>
        {{ filter?.category ? filter?.category?.name : '-' }}
      </td>
      <td>
        {{ filter?.lockedBy?.name ?? '-' }}
      </td>
      <td>
        <sb-comp-display-modified [data]="filter" [hideTooltip]="true"></sb-comp-display-modified>
      </td>
      <td>
        <sb-comp-display-created [data]="filter"></sb-comp-display-created>
      </td>
      <td class="sticky-col last-col">
        <div class="tw-flex tw-gap-2.5">

          @if (!isInModalContext && !isInIntegratedContext) {
            @if (hasEditRight(filter?.type)) {
              @if (filter?.hidden) {
                <button
                  type="button"
                  sb-button-primary
                  [iconButton]="true"
                  [icon]="'eye'"
                  [color]="'blue'"
                  (click)="toggleHideFilter(filter)"
                  sbTooltip="{{ ( 'lang.globals.show' | translate) }}">
                </button>
              } @else {

                <button
                  type="button"
                  sb-button-secondary
                  [iconButton]="true"
                  [icon]="'eyeNone'"
                  [color]="'blue'"
                  (click)="toggleHideFilter(filter)"
                  sbTooltip="{{ ( 'lang.globals.hide' | translate) }}">
                </button>
              }
            }

            <sb-split-button
              [splitButtonItems]="filter.sbButtons ?? []"
              (selectedAction)="resolveSplitButtonAction(filter, $event)"
            ></sb-split-button>
          } @else {
            <button
              type="button"
              sb-button-secondary
              [iconButton]="true"
              [icon]="'selection'"
              [color]="'blue'"
              (click)="selectFilter(filter)"
              sbTooltip="{{'lang.globals.selectFilter' | translate }}">
            </button>
          }
        </div>
      </td>
    </tr>
  </ng-template>

</sb-table-wrapper-new>
